// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";

// Auth
import { isUserLoggedIn } from "@core/auth/utils";

// @Utility
import alertText from "@utility/app/alertText";
import { normalizeObjectKeyGameList } from "@utility/app/game";

const SET_GAME_ALL = 'app/game/SET_GAME_ALL';
const SET_GAME_POPPULAR_ALL = 'app/game/SET_GAME_POPPULAR_ALL';
const SET_GAME_LIKE_LIST = 'app/game/SET_GAME_LIKE_LIST';
const SET_GAME_LAST_ALL = 'app/game/SET_GAME_LAST_ALL';
const SET_GAME_DEMO = 'app/game/SET_GAME_DEMO';
const SET_SCROLL_POSITION = 'app/game/SET_SCROLL_POSITION';
const SET_SCROLL_MOVE = 'app/game/SET_SCROLL_MOVE';
const SET_OPEN_GAME = 'app/game/SET_OPEN_GAME';
const SET_LOAD_GAME_ALL = 'app/game/SET_LOAD_GAME_ALL';

function loadGameList(dataJson, itemsGameList, reqStatus = true, dataGameList = [], setGameLoadStatus) {
    return async dispatch => {
        const {
            camp,
            type,
            statusUseScroll
        } = dataJson;

        try {
            if (!reqStatus) {
                if (setGameLoadStatus) {
                    setGameLoadStatus(true);
                }

                const dataList = setGameList(camp, type, statusUseScroll, dataGameList, itemsGameList);

                dispatch({
                    type: SET_GAME_ALL,
                    payload: {
                        items: dataList
                    }
                });

                return;
            }

            dispatch(setLoadGameList(true));
            const res = await apiServices(dataJson, "post", `/general/list/games-cache/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`);
            const { code, result } = res;
            dispatch(setLoadGameList(false));
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if ([0, 200, 23].includes(code)) {
                const dataList = setGameList(camp, type, statusUseScroll, result, itemsGameList);
                if (setGameLoadStatus) {
                    setGameLoadStatus(true);
                }

                dispatch({
                    type: SET_GAME_ALL,
                    payload: {
                        items: dataList
                    }
                });
            } else {
                if (setGameLoadStatus) {
                    setGameLoadStatus(true);
                }
                console.warn("Game list load failed: code", code);
            }
        } catch (error) {
            console.error("loadGameList error:", error);
            if (setGameLoadStatus) {
                setGameLoadStatus(true);
            }
        }
    };
}

function setGameList(camp = "", type, statusUseScroll, dataRes, itemsGameList) {
    const dataCamp = camp === "" ? "all" : camp;

    const prevDataByType = itemsGameList?.[type] || {};
    const prevDataByCamp = prevDataByType?.[dataCamp] || { data: [] };

    const newDataList = dataRes?.data || [];

    // รวมข้อมูลเดิม + ใหม่
    let combinedData = statusUseScroll
        ? [...(prevDataByCamp.data || []), ...newDataList]
        : [...newDataList];

    // กำจัดซ้ำโดยใช้ id เป็น key
    const uniqueData = Array.from(
        new Map(combinedData.map(item => [item.id, item])).values()
    );

    return {
        ...itemsGameList,
        [type]: {
            ...prevDataByType,
            [dataCamp]: {
                ...dataRes, // result มีฟิลด์อื่นๆ เช่น count
                data: uniqueData
            }
        }
    };
}

function setGameDemo(data) {
    return {
        type: SET_GAME_DEMO,
        payload: {
            items: data
        }
    }
}

function setScrollStatus(data) {
    return {
        type: SET_SCROLL_POSITION,
        payload: {
            items: data
        }
    }
}

function setLoadGameList(data) {
    return {
        type: SET_LOAD_GAME_ALL,
        payload: {
            items: data
        }
    }
}

function setScrollMove(data) {
    return {
        type: SET_SCROLL_MOVE,
        payload: {
            items: data
        }
    }
}

function openGame(camp, code, isMobile, setProcessing) {
    return (dispatch) => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        let mode = "demo"
        if (isUserLoggedIn()) {
            mode = "real"
        }

        const dataObj = {
            "game_code": code,
            "mode": mode,
            "is_mobile": isMobile,
            "camp": camp.toLowerCase(),
        };

        apiServices(dataObj, "POST", `/general/generate/open-game/camp`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (setProcessing) {
                setProcessing(false);
            }

            if (statusCode === 0 || statusCode === 200) {
                const urlGame = result?.url;
                if (urlGame) {
                    dispatch({
                        type: SET_OPEN_GAME,
                        payload: {
                            items: {
                                url: urlGame,
                                text: "สำเร็จ"
                            }
                        }
                    });
                }
                else {
                    if (mode === "demo") {
                        dispatch({
                            type: SET_OPEN_GAME,
                            payload: {
                                items: {
                                    url: null,
                                    text: "เกมนี้ไม่สามารถเล่นในโหมดทดลองได้ กรุณาเลือกเล่นเกมอื่น ๆ"
                                }
                            }
                        });
                    }
                    else {
                        dispatch({
                            type: SET_OPEN_GAME,
                            payload: {
                                items: {
                                    url: null,
                                    text: "ไม่สามารถเล่นเกมได้ กรุณาลองใหม่อีกครั้ง"
                                }
                            }
                        });
                    }
                }
            }
            else {
                if (mode === "demo") {
                    dispatch({
                        type: SET_OPEN_GAME,
                        payload: {
                            items: {
                                url: null,
                                text: "เกมนี้ไม่สามารถเล่นในโหมดทดลองได้ กรุณาเลือกเล่นเกมอื่น ๆ"
                            }
                        }
                    });
                }
                else {
                    let dataText = alertText(statusCode);
                    dispatch({
                        type: SET_OPEN_GAME,
                        payload: {
                            items: {
                                url: null,
                                text: dataText.textAlert
                            }
                        }
                    });
                }
            }
        });
    };
}

function loadGamePoppularList() {
    return dispatch => {
        apiServices({}, "get", `/common/section/popular/day/games-v2/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: SET_GAME_POPPULAR_ALL,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: SET_GAME_POPPULAR_ALL,
                    payload: {
                        items: []
                    }
                })
            }
        });
    }
}

function loadGameLastAll() {
    return dispatch => {
        apiServices({}, "get", "/customer/profile/lastgame").then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: SET_GAME_LAST_ALL,
                    payload: {
                        items: normalizeObjectKeyGameList(result)
                    }
                });
            }
        });
    }
}

function loadGameLikeList() {
    return dispatch => {
        apiServices({}, "get", "/general/list/game/like").then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: SET_GAME_LIKE_LIST,
                    payload: {
                        items: normalizeObjectKeyGameList(result)
                    }
                });
            }
        });
    }
}

function selectGameLike(gameID, statusLike = false, actionLoad = false) {
    return dispatch => {
        let pathDefault = "/customer/profile/game-like";
        let methodDefault = "put";

        const dataObj = {
            "game_id": gameID
        };

        if (!statusLike) {
            methodDefault = "delete";
            pathDefault = pathDefault + `/${dataObj.game_id}`;
        }

        apiServices(dataObj, methodDefault, pathDefault).then((data) => {
            const { code: statusCode } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                if (actionLoad) {
                    dispatch(loadGameLikeList());
                }
            }
        });
    }
}

export {
    SET_GAME_ALL,
    SET_GAME_DEMO,
    SET_SCROLL_POSITION,
    SET_SCROLL_MOVE,
    SET_OPEN_GAME,
    SET_LOAD_GAME_ALL,
    SET_GAME_POPPULAR_ALL,
    SET_GAME_LAST_ALL,
    SET_GAME_LIKE_LIST,
    loadGameList,
    setGameDemo,
    setScrollStatus,
    setScrollMove,
    openGame,
    setLoadGameList,
    loadGamePoppularList,
    loadGameLastAll,
    loadGameLikeList,
    selectGameLike
}